import { render, staticRenderFns } from "./ActivityUser.vue?vue&type=template&id=efe5991e"
import script from "./ActivityUser.vue?vue&type=script&lang=js"
export * from "./ActivityUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports